// extracted by mini-css-extract-plugin
export default {"root":"Progress_root__YnOTZ","progressClassName":"Progress_progressClassName__ak+ug"};